// extracted by mini-css-extract-plugin
export default {"lead":"Lead_lead__JqS1I"};